

export const getNeedsConfigurationUpdateConfigForProjectId = state => projectId => {
    return state.projectsNeedingConfigurationUpdate[projectId];
}
